export const filters = {
  "image/png": [".png"],
  "text/jpg": [".jpg"],
};
